import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import ErrorIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles(theme => ({
  spacer: {
    marginBottom: theme.spacing(2)
  },
  paperRoot: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2)
  },
  errorIcon: {
    fontSize: '2rem',
    marginRight: theme.spacing(2),
    color: theme.palette.warning.main
  }
}));

const UserAccessNotEnabledMessage = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="sm">
      <div className={classes.spacer} />
      <Paper classes={{ root: classes.paperRoot }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="row"
        >
          <ErrorIcon classes={{ root: classes.errorIcon }} />
          <div>
            Access to iFoodPPSI is not enabled.Please contact administrator.
          </div>
        </Box>
      </Paper>
    </Container>
  );
};

export default UserAccessNotEnabledMessage;
